export default __webpack_public_path__ + "static/media/landing06.dc918c3c.png";